import classNames from 'classnames'
import { useRouter } from 'next/router'
import { useCallback, useMemo } from 'react'
import {
  CompetitionType,
  IAICompetitionContentObj,
  IAICompetitionDetail,
  StartStatusEnum,
  getCompetitionDetail_marketingModule_competition,
} from '~/graphqls/types'
import { useMute } from '~/hooks/ai/useMute'
import { useStores } from '~/hooks/useStores'
import { useValidateAuth } from '~/hooks/useValidateAuth'
import styles from './CompetitionHeader.module.css'
import dayjs from 'dayjs'

const formatTime = (timestrap: number) => {
  return dayjs(timestrap * 1000).format('YYYY/MM/DD')
}

/** 大赛详情格式化 */
export function formatBannerRes(
  res?: getCompetitionDetail_marketingModule_competition | null
) {
  if (!res) return {}
  const contentObj: IAICompetitionContentObj =
    res?.content && JSON.parse(res?.content)
  return {
    ...res,
    ...contentObj,
  }
}

export const CompetitionHeader: React.FC<{
  banner: IAICompetitionDetail
}> = ({ banner }) => {
  const { validateIsLogin } = useValidateAuth()
  const { store } = useStores()
  const { showMute } = useMute()
  const router = useRouter()

  // 备注：运营提的奇怪的逻辑
  const { canContribute, contributeWait } = useMemo(
    () => ({
      canContribute: banner.contributeTime
        ? new Date().getTime() > banner.contributeTime * 1000 &&
          new Date().getTime() <= banner.endDateTime * 1000
        : banner.startStatus === StartStatusEnum.ING,
      // 即将开始投稿
      contributeWait: new Date().getTime() < banner.contributeTime * 1000,
    }),
    [banner]
  )

  const onContribution = useCallback(async () => {
    if (validateIsLogin()) {
      if (store.userinfo?.muzzleStatus) {
        showMute(store.userinfo?.muzzleEndTime)
        return
      }

      router.push({
        pathname: '/ai-competition/contribution',
        query: {
          competitionId: banner.id,
          competitionType:
            banner.type === CompetitionType.VIDEO
              ? 'video'
              : banner.type === CompetitionType.DRAFT
              ? 'draft'
              : 'normal',
        },
      })
    }
  }, [banner, store, validateIsLogin])

  return (
    <div
      className="h-[483px] m-auto rounded-2xl flex items-center cursor-pointer"
      style={{
        background: `url(${banner?.banner_pc}) no-repeat center center`,
        backgroundSize: 'cover',
      }}
      onClick={() => {
        if (!!banner?.hiddenText) {
          onContribution()
        }
      }}
    >
      <div
        className={classNames({
          [styles.content]: !!banner?.hiddenText,
          ['ml-[64px]']: !banner?.hiddenText,
        })}
      >
        {!banner?.hiddenText && (
          <div className={styles.banner}>
            <h2>{banner.name}</h2>
            <p></p>
            {banner?.theme && <div>创作主题：{banner?.theme}</div>}
            {banner?.contributeNotice && (
              <div>投稿须知：{banner?.contributeNotice}</div>
            )}
            <div>
              投稿时间：{formatTime(banner?.contributeTime as number)} -{' '}
              {formatTime(banner?.contributeEndTime as number)}
            </div>
          </div>
        )}
        {canContribute && (
          <button
            className={classNames(styles.btn, {
              [styles.pos]: !!banner?.hiddenText,
            })}
            onClick={onContribution}
          >
            立即投稿
          </button>
        )}
        {contributeWait && (
          <button
            className={classNames(styles.btn, {
              [styles.pos]: !!banner?.hiddenText,
            })}
          >
            即将开始
          </button>
        )}
      </div>
    </div>
  )
}
